export const getSyntaxAvailability = (state) => (category) =>
  state.adom?.deviceSyntax?.syntaxMap?.[category];
export const isSyntaxAvailabilityLoaded = (state) =>
  !!state.adom?.deviceSyntax?.loaded;
